import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { Answer, DatabaseReport } from '../../../shared/domain/reports/types.no-deps'
import type { Nullable, UUID } from '../../../shared/lib/typeHelpers.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/reports/confirmAction' }

type Params = never

type Body = {
    startDate: Date
    coordinates: DatabaseReport['coordinates']
    endDate: Date
    clientId?: UUID
    scheduledInstance: UUID
    teamDoneFor?: Nullable<number>
    answers?: Answer[]
    signature?: string
    signedAtTime?: Date
}

type Query = never

type Output = {
    id: number
}

export type ConfirmActionEndpoint = Endpoint<Params, Body, Query, Output>

export const confirmActionRequest = (request: Request, args: RequestArgs<ConfirmActionEndpoint>) =>
    request<ConfirmActionEndpoint>(route, args)
